<template>
  <div class="filtres">
    <h2>Paramétrage des filtres</h2>
    <br />
    <div class="card shadow mb-4">
      <!-- Card Header - Dropdown -->
      <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
        <h6 class="m-0 font-weight-bold text-primary">Personnalisation des filtres</h6>
      </div>
      <!-- Card Body -->
      <div class="p-3">
        <table class="table table-responsive">
          <tr>
            <th>Label</th>
            <th>Filtre Ouvert</th>
            <th>Description</th>
            <th></th>

          </tr>
          <tr v-for="filter in filters" :key="filter.Id">
            <td>{{ filter.Label }}</td>
            <td v-if="filter.Value == 1"><input class="form-check-input" id="value" type="checkbox" v-model="filter.Value" checked="checked" /></td>
            <td v-else><input class="form-check-input" id="value" type="checkbox" v-model="filter.Value" /></td>
            <td>{{ filter.Description }}</td>
            <td><button type="button" class="btn-save" v-on:click="updateVisibilityFilters(filter)">Enregistrer</button></td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
  import { apiFetch, apiPost } from "@/utils";
  import { initVisibilityFilters } from "@/utils/adminMapsMixin";

  export default {
    name: 'VisibilityFilters',
    data() {
      return {
        filters: []
      }
    },
    mounted() {
      this.initData();
    },
    methods: {
      initData() {
        initVisibilityFilters().then(res => this.filters = res);
      },

      updateVisibilityFilters(filter) {
        if (filter.Value == 0 || filter.Value == 1) {
            apiPost("maps/filters/update/byid?id=" + filter.Id + "&value=" + filter.Value)
            .then(e => {
              this.initData();
              alert("Sauvegarde effectuée avec succés");
              console.log(e);
            })
            .catch(e => {
              alert("Erreur de sauvegarde");
              console.log(e);
            });
        }
        else {
          alert("Veuillez sélectionner une des valeurs suivantes : 0 ou 1")
        }
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  div.filtres {
    width: 65%;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Admin/AdminMaps/Filtres.vue